module.exports = __webpack_public_path__ + "assets/img/TrendingNow_Science.e35c1ba7-ps.jpg";